import { FixMeLater } from '.';

/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */
export function createChainedFunction<Args extends FixMeLater[], This>(
    ...funcs: Array<(this: This, ...args: Args) => FixMeLater>
): (this: This, ...args: Args) => void {
    return funcs.reduce(
        (acc, func) => {
            if (func == null) {
                return acc;
            }

            return function chainedFunction(...args) {
                acc.apply(this, args);
                func.apply(this, args);
            };
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        () => {}
    );
}
